<script>
  import 'vue-strap/dist/vue-strap-lang';
  import { datepicker } from 'vue-strap';
  import Radio from '~componentes/Radio.vue';
  import formPerguntaServico from '~modulos/form-pergunta/servico';
  import RespostasParticipacaoAcionaria from './FormRespostasParticipacaoAcionaria.vue';
  import RespostasRelacaoContratual from './FormRespostasRelacaoContratual.vue';
  import RespostasRelacaoFundacao from './FormRespostasRelacaoFundacao.vue';
  import RespostasEmpresaReferencia from './FormRespostasEmpresaReferencia.vue';
  
  export default {
    components: { Radio, datepicker, RespostasParticipacaoAcionaria, RespostasRelacaoContratual, RespostasRelacaoFundacao, RespostasEmpresaReferencia },
    props: {
      formRespostasFornecedor: {
        type: Array,
        required: true,
      },
      formRespostasParticipacaoAcionaria: {
        type: Array,
        required: true,
      },
      formRespostasRelacaoContratual: {
        type: Array,
        required: true,
      },
      formRespostasEmpresaReferencia: {
        type: Array,
        required: true,
      },
      formRespostasRelacaoFundacao: {
        type: Array,
        required: true,
      },
      habilitarDUEDiligence: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        formPerguntas: [],
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      exibirPergunta(id) {
        return this.formPerguntas.length > 0
          ? `${id}) ${this.formPerguntas[id - 1].pergunta.replaceAll('VAR_FUNDACAO', this.configuracao.abreviaturaFundacao)}`
          : `${id}) Pergunta ${id}`;
      },
      carregarFormPerguntas() {
        return formPerguntaServico.
          lista()
          .then(formPerguntas => {
            this.formPerguntas = formPerguntas;
          }); 
      },
      validar(valido) {

        if (!valido) throw new Error("validacao com erro");


        return this.habilitarDUEDiligence
          ? this.$validator.validateAll()
          : true;
      },
      validarDadosNaoEnviados(){
        if(!this.$refs.respostasEmpresaReferencia.validarDadosNaoEnviados()){
          return false;
        }

        if(!this.$refs.respostasParticipacaoAcionaria.validarDadosNaoEnviados()){
          return false;
        }
        
        if(!this.$refs.respostasRelacaoContratual.validarDadosNaoEnviados()){
          return false;
        }
        
        if(!this.$refs.respostasRelacaoFundacao.validarDadosNaoEnviados()){
          return false;
        }
        return true;
      },
    },
    mounted() {
      this.carregarFormPerguntas();

    },
  }
</script>

<template>
  <div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group form-group-resposta" :class="{'required': habilitarDUEDiligence, 'has-error': errors.has('formResposta01a') && errors.has('formResposta01b') &&
             errors.has('formResposta01c')}">
          <label class="control-label" for="pergunta01">{{ exibirPergunta(this.formRespostasFornecedor[0].idFormPergunta) }}</label>
          <br />
          <radio v-model="formRespostasFornecedor[0].resposta"
                 selected-value="1"
                 type="success"
                 :inline="true"
                 data-vv-name="formResposta01a"
                 v-validate="habilitarDUEDiligence ? 'required' : ''"
                 class="margin-right-10">
            Sim
          </radio>
          <radio v-model="formRespostasFornecedor[0].resposta"
                 selected-value="0"
                 type="success"
                 :inline="true"
                 data-vv-name="formResposta01b"
                 v-validate="habilitarDUEDiligence ? 'required' : ''"
                 class="margin-right-10">
            Não
          </radio>
          <radio v-model="formRespostasFornecedor[0].resposta"
                 selected-value="2"
                 type="success"
                 data-vv-name="formResposta01c"
                 v-validate="habilitarDUEDiligence ? 'required' : ''"
                 :inline="true">
            Não responder
          </radio>

          <p class="text-danger" v-show="errors.has('formResposta01a') && errors.has('formResposta01b') && errors.has('formResposta01c')">Selecione uma opção</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="panel-resposta">
        <respostas-participacao-acionaria ref="respostasParticipacaoAcionaria"
                                          :formRespostasParticipacaoAcionaria="formRespostasParticipacaoAcionaria">
        </respostas-participacao-acionaria>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group form-group-resposta" :class="{'required': habilitarDUEDiligence, 'has-error': errors.has('formResposta02a') && errors.has('formResposta02b') &&
             errors.has('formResposta02c')}">
          <label class="control-label" for="pergunta02">{{ exibirPergunta(this.formRespostasFornecedor[1].idFormPergunta) }}</label>
          <br />
          <radio v-model="formRespostasFornecedor[1].resposta"
                 selected-value="1"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta02a"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Sim
          </radio>
          <radio v-model="formRespostasFornecedor[1].resposta"
                 selected-value="0"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta02b"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não
          </radio>
          <radio v-model="formRespostasFornecedor[1].resposta"
                 selected-value="2"
                 type="success"
                 :inline="true"
                 data-vv-name="formResposta02c"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não responder
          </radio>
          <p class="text-danger" v-show="errors.has('formResposta02a') && errors.has('formResposta02b') && errors.has('formResposta02c')">Selecione uma opção</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="panel-resposta">
        <respostas-relacao-contratual ref="respostasRelacaoContratual"
                                      :formRespostasRelacaoContratual="formRespostasRelacaoContratual">
        </respostas-relacao-contratual>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group" :class="{'required': habilitarDUEDiligence, 'has-error': errors.has('formResposta03a') && errors.has('formResposta03b') &&
             errors.has('formResposta03c')}">
          <label class="control-label" for="pergunta03">{{ exibirPergunta(this.formRespostasFornecedor[2].idFormPergunta) }}</label>
          <br />
          <radio v-model="formRespostasFornecedor[2].resposta"
                 selected-value="1"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta03a"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Sim
          </radio>
          <radio v-model="formRespostasFornecedor[2].resposta"
                 selected-value="0"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta03b"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não
          </radio>
          <radio v-model="formRespostasFornecedor[2].resposta"
                 selected-value="2"
                 type="success"
                 :inline="true"
                 data-vv-name="formResposta03c"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não responder
          </radio>
          <p class="text-danger" v-show="errors.has('formResposta03a') && errors.has('formResposta03b') && errors.has('formResposta03c')">Selecione uma opção</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="panel-resposta">
        <respostas-relacao-fundacao ref="respostasRelacaoFundacao"
                                    :formRespostasRelacaoFundacao="formRespostasRelacaoFundacao">
        </respostas-relacao-fundacao>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group" :class="{'required': habilitarDUEDiligence, 'has-error': errors.has('formResposta04a') && errors.has('formResposta04b') &&
             errors.has('formResposta04c')}">
          <label class="control-label" for="pergunta04">{{ exibirPergunta(this.formRespostasFornecedor[3].idFormPergunta) }}</label>
          <br />
          <radio v-model="formRespostasFornecedor[3].resposta"
                 selected-value="1"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta04a"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Sim
          </radio>
          <radio v-model="formRespostasFornecedor[3].resposta"
                 selected-value="0"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta04b"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não
          </radio>
          <radio v-model="formRespostasFornecedor[3].resposta"
                 selected-value="2"
                 type="success"
                 :inline="true"
                 data-vv-name="formResposta04c"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não responder
          </radio>
          <p class="text-danger" v-show="errors.has('formResposta04a') && errors.has('formResposta04b') && errors.has('formResposta04c')">Selecione uma opção</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group" :class="{'required': habilitarDUEDiligence, 'has-error': errors.has('formResposta05a') && errors.has('formResposta05b') &&
             errors.has('formResposta05c')}">
          <label class="control-label" for="pergunta05">{{ exibirPergunta(this.formRespostasFornecedor[4].idFormPergunta) }}</label>
          <br />
          <radio v-model="formRespostasFornecedor[4].resposta"
                 selected-value="1"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta05a"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Sim
          </radio>
          <radio v-model="formRespostasFornecedor[4].resposta"
                 selected-value="0"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta05b"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não
          </radio>
          <radio v-model="formRespostasFornecedor[4].resposta"
                 selected-value="2"
                 type="success"
                 :inline="true"
                 data-vv-name="formResposta05c"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não responder
          </radio>
          <p class="text-danger" v-show="errors.has('formResposta05a') && errors.has('formResposta05b') && errors.has('formResposta05c')">Selecione uma opção</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group" :class="{'required': habilitarDUEDiligence, 'has-error': errors.has('formResposta06a') && errors.has('formResposta06b') &&
             errors.has('formResposta06c')}">
          <label class="control-label" for="pergunta06">{{ exibirPergunta(this.formRespostasFornecedor[5].idFormPergunta) }}</label>
          <br />
          <radio v-model="formRespostasFornecedor[5].resposta"
                 selected-value="1"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta06a"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Sim
          </radio>
          <radio v-model="formRespostasFornecedor[5].resposta"
                 selected-value="0"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta06b"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não
          </radio>
          <radio v-model="formRespostasFornecedor[5].resposta"
                 selected-value="2"
                 type="success"
                 :inline="true"
                 data-vv-name="formResposta06c"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não responder
          </radio>
          <p class="text-danger" v-show="errors.has('formResposta06a') && errors.has('formResposta06b') && errors.has('formResposta06c')">Selecione uma opção</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group" :class="{'required': habilitarDUEDiligence, 'has-error': errors.has('formResposta07a') && errors.has('formResposta07b') &&
             errors.has('formResposta07c')}">
          <label class="control-label" for="pergunta07">{{ exibirPergunta(this.formRespostasFornecedor[6].idFormPergunta) }}</label>
          <br />
          <radio v-model="formRespostasFornecedor[6].resposta"
                 selected-value="1"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta07a"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Sim
          </radio>
          <radio v-model="formRespostasFornecedor[6].resposta"
                 selected-value="0"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta07b"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não
          </radio>
          <radio v-model="formRespostasFornecedor[6].resposta"
                 selected-value="2"
                 type="success"
                 :inline="true"
                 data-vv-name="formResposta07c"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não responder
          </radio>
          <p class="text-danger" v-show="errors.has('formResposta07a') && errors.has('formResposta07b') && errors.has('formResposta07c')">Selecione uma opção</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group" :class="{'required': habilitarDUEDiligence, 'has-error': errors.has('formResposta08a') && errors.has('formResposta08b') &&
             errors.has('formResposta08c')}">
          <label class="control-label" for="pergunta08">{{ exibirPergunta(this.formRespostasFornecedor[7].idFormPergunta) }}</label>
          <br />
          <radio v-model="formRespostasFornecedor[7].resposta"
                 selected-value="1"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta08a"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Sim
          </radio>
          <radio v-model="formRespostasFornecedor[7].resposta"
                 selected-value="0"
                 type="success"
                 :inline="true"
                 class="margin-right-10"
                 data-vv-name="formResposta08b"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não
          </radio>
          <radio v-model="formRespostasFornecedor[7].resposta"
                 selected-value="2"
                 type="success"
                 :inline="true"
                 data-vv-name="formResposta08c"
                 v-validate="habilitarDUEDiligence ? 'required' : ''">
            Não responder
          </radio>
          <p class="text-danger" v-show="errors.has('formResposta08a') && errors.has('formResposta08b') && errors.has('formResposta08c')">Selecione uma opção</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group" :class="{'has-error': errors.has('formResposta09')}">
          <label class="control-label" for="pergunta09">{{ exibirPergunta(this.formRespostasFornecedor[8].idFormPergunta) }}</label>
          <!--
          <br />
          <radio v-model="formRespostasFornecedor[8].resposta"
                 selected-value="1"
                 type="success"
                 :inline="true"
                 class="margin-right-10">
            Sim
          </radio>
          <radio v-model="formRespostasFornecedor[8].resposta"
                 selected-value="0"
                 type="success"
                 :inline="true"
                 class="margin-right-10">
            Não
          </radio>
          <radio v-model="formRespostasFornecedor[8].resposta"
                 selected-value="2"
                 type="success"
                 :inline="true">
            Não responder
          </radio>
          -->
        </div>
      </div>
    </div>

    <div class="row">
      <div class="panel-resposta">
        <respostas-empresa-referencia ref="respostasEmpresaReferencia"
                                          :formRespostasEmpresaReferencia="formRespostasEmpresaReferencia">
        </respostas-empresa-referencia>
      </div>
    </div>

  </div>
</template>

<style>
  .panel-resposta {
    background: transparent !important;
    padding-left: 10px;
    padding-right: 10px;
    border-width: 1px;
    border-color: lightgray;
    border-radius: 3px;
    border-style: solid;
    margin-left: 15px;
    margin-right: 15px;
    margin-bottom: 15px;
  }
  .form-group-resposta {
    margin-bottom: 0px;
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/fornecedor/componentes/compartilhado/FormDueDiligence.vue